import styled from 'styled-components';
import { COLORS, FONTS } from './../../ui';

interface Props {
  position?: string;
}

const getPositionTooltip = {
  top: 'bottom: 108%',
  bottom: 'top: 108%',
  left: 'right: 108%',
  right: 'left: 108%'
};

export const TooltipStyled = styled.span`
  display: none;
  position: absolute;
  width: max-content;
  background-color: ${COLORS.TOOLTIP_BLACK};
  color: ${COLORS.WHITE};
  font-size: 12px;
  padding: 6px 11px;
  border-radius: 4px;
  z-index: 10;
  ${(props: Props) => getPositionTooltip[props.position]};
`;

TooltipStyled.defaultProps = {
  position: 'top'
};

export const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  font-family: ${FONTS.ROBOTO_REGULAR};

  &:hover {
    ${TooltipStyled} {
      display: block;
    }
  }
`;

TooltipStyled.displayName = 'TooltipStyled';
Wrapper.displayName = 'Wrapper';
